export default __webpack_public_path__ + "static/media/42.296977ce.jpg";